<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${purchasesInvoice.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="purchasesInvoice" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "purchases-invoice-view-logs",

  components: { LogListTable },

  props: ["purchasesInvoice"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
